import Avatar from "material-ui/Avatar";

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/uielements/avatars/index.js